Vue.component("edit-mailbox", {
    props: ["mailbox"],
    data () {
        return {
            mutableMailbox: this.mailbox,
            form: new AppForm(this.mailbox),
            isUpdatingMailboxStatus: false,
            showDefaultUsersList: false,
            defaultUsers: [],
            editorOption: {
                modules: {
                    toolbar: "#toolbar"
                }
            },
        };
    },
    watch: {
        mailbox: function (newVal) {
            this.mutableMailbox = newVal;
            this.form = new AppForm(newVal);
        }
    },
    methods: {
        update () {
            App.patch("/settings/mailboxes/" + this.mailbox.id + "/update", this.form)
            .then((response) => {
                toastr.success("Mailbox updated!");
                this.$emit("mailbox-updated", response);
            });
        },
        updateMailboxStatus (status) {
            this.isUpdatingMailboxStatus = true;
            this.showDefaultUsersList = false;
            this.defaultUsers = [];

            let statusForm = new AppForm({"status": status});
            App.patch("/settings/mailboxes/" + this.mailbox.id + "/update", statusForm)
            .then(response => {
                this.isUpdatingMailboxStatus = false;
                toastr.success("Mailbox updated!");
                this.$emit("mailbox-updated", response);
            })
            .catch(errors => {
                this.isUpdatingMailboxStatus = false;
                if (statusForm.errors.has('status')){
                    toastr.error(statusForm.errors.get('status'))
                } else {
                toastr.error("Error updating mailbox status to " + status);
                }
                if (!_.isUndefined(errors.data)) {
                    this.showDefaultUsersList = true;
                    this.defaultUsers = errors.data;
                }
            });

        },
        onEditorReady (editor) {
            editor.on("text-change", function (delta, oldDelta, source) {
                let img = $(".ql-editor img");
                if (img && img.attr("src") && (img.attr("src").length * 0.75) > 300000) {
                    img.remove();
                    toastr.error("Selected image file size is too large to be used as an email signature. Please resize image and try again.");
                }
            });
        },
        back () {
            this.$emit("close-mailbox-form");
        }
    }
});
